import { MutableRefObject, RefObject, useLayoutEffect } from 'react'

type Props = {
  selectedFilter: string | boolean
  panelRef: RefObject<HTMLDivElement | null>
  filtersRef: RefObject<HTMLDivElement | null>
  buttonRefs: MutableRefObject<Record<string, HTMLButtonElement | null>>
}

export const usePanelPosition = ({
  selectedFilter,
  panelRef,
  filtersRef,
  buttonRefs,
}: Props) => {
  useLayoutEffect(() => {
    const panel = panelRef.current
    const filters = filtersRef.current
    if (!panel || !filters) return
    if (!selectedFilter || typeof selectedFilter !== 'string') return

    const overlayTop = filters.offsetTop
    const belowTop = filters.offsetTop + filters.offsetHeight

    let left = 0
    const button = buttonRefs.current[selectedFilter]
    if (button) {
      const containerRect = filters.getBoundingClientRect()
      const buttonRect = button.getBoundingClientRect()
      const panelRect = panel.getBoundingClientRect()
      const buttonLeft = buttonRect.left - containerRect.left - 10
      left = Math.max(
        0,
        Math.min(buttonLeft, containerRect.width - panelRect.width)
      )
    }

    panel.style.setProperty('--panel-top-overlay', `${overlayTop}px`)
    panel.style.setProperty('--panel-top-below', `${belowTop}px`)
    panel.style.setProperty('--panel-left', `${left}px`)
  }, [selectedFilter])
}
